import React, { useState, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useColsEffect, useGridRef } from "../../utils/tables";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EventTooltip from "./EventTooltip";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import { FilterMatchMode } from "primereact/api";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import { Dialog } from "primereact/dialog";


const SystemEventsTable = ({ eventsData }) => {
    const grid = useRef(null);
    const { t, i18n } = useTranslation();
    const [selectedEvents, setSelectedEvents] = useState(false);
    const [dialogState, setDialogState] = useState(false);
    const dialogRef = useRef(null);
    const [affectedColumns, setAffectedColumns] = useState([]);
    const [data, setData] = useState(null);
    const namesTT = useMemo(() => [
        t("systemEvents.table.parametro"),
        t("systemEvents.table.detalle")
    ], [t]);

    const names = useMemo(() =>[
        "ID",
        t("systemEvents.table.fecha"),
        t("systemEvents.table.usuario"),
        t("systemEvents.table.evento"),
        t("systemEvents.item"),
        t("systemEvents.table.detalleEvento")
    ], [t]);

    useColsEffect(grid, names);

    const TooltipTemplate = (props) => {
        const template = <EventTooltip data={props} setData={setData} dialogState={dialogState} setDialogState={setDialogState}
            affectedColumns={affectedColumns} setAffectedColumns={setAffectedColumns}
        />;
        return (
            <div className='d-flex justify-content-center align-items-center'>
                <TooltipPrime id={`toolBitacora-${props.evento_sistema_id}`}  content={<>{template}</>} position="left" autoHide={false} >
                    <FontAwesomeIcon  size="lg" icon={faInfoCircle} style={{ color: "lightblue" }} />
                </TooltipPrime>
            </div>
        );
    };

    if (!Array.isArray(eventsData)) return null;
    return (<div className='eventsTable'>
        {
            dialogState &&
                <Dialog
                    id='dialogBitacora'
                    className='dialog-prime'
                    transitionOptions={{ effect: "Zoom", duration: 300, delay: 0 }}
                    baseZIndex={1040}
                    visible={dialogState}
                    onHide={() => setDialogState(false)}
                    style={{width:"600px",height:"80%"}}
                    ref={dialogRef}
                    closable
                    header={t("systemEvents.table.detalleEvento")}
                >
                    <div>
                        <>
                            <ul>
                                <li>
                                    {t("systemEvents.table.fecha")}: { data.fecha }
                                </li>
                                <li>
                                    {t("systemEvents.table.usuario")}: { data.usuario }
                                </li>
                                <li>
                                    {t("systemEvents.table.evento")}: { data.descripcionTrans }
                                </li>
                                <li>
                                    {t("systemEvents.item")}: { data.itemColumn }
                                </li>
                            </ul>
                            <DataTablePrime
                                tableName="eventTooltipTable"
                                t={t}
                                items={affectedColumns}
                                size="small"
                                fields={[
                                    {field:"columnText",header:namesTT[0], bodyStyle:{textAlign:"center"}},
                                    {field:"valueText",header:namesTT[1], bodyStyle:{textAlign:"center", textWrap:"wrap"}},
                                ]}
                            />
                        </>
                    </div>
                </Dialog>
        }
        <DataTablePrime
            tableName="eventTable"
            t={t}
            selectionMode="single"
            selection={selectedEvents}
            onSelectionChange={(e) => setSelectedEvents(e.value)}
            dataKey="id"
            items={eventsData}
            filters={{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            }}
            size="small"
            header={eventsData?.length > 10 ? "search":null}
            paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
            paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            globalFilterFields={["usuario", "descripcionTrans", "itemColumn"]}
            fields={[
                {field:"evento_sistema_id",hidden:true, header:names[0], bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"fecha",header:names[1], bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"usuario",header:names[2], bodyStyle:{textAlign:"center", sortable:true}},
                {field:"descripcionTrans",header:names[3], bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"itemColumn",header:names[4], bodyStyle:{textAlign:"center"}, sortable:true},
                {field:"data_json",body:TooltipTemplate, header:names[5], bodyStyle:{textAlign:"center"}, sortable:true},
            ]}
        />
    </div>);
};

export default SystemEventsTable;
